import config from '@/utils/Config'
import {post } from '@/utils/request'

export function getCatchphraseAdminList(params = {}) {
    return post(config.BASE_URL, config.getCatchphraseAdminListUrl, params)
}

export function saveCatchphrase(params = {}) {
    return post(config.BASE_URL, config.saveCatchphraseUrl, params)
}

export function delCatchphrase(params = { id: id }) {
    return post(config.BASE_URL, config.delCatchphraseUrl, params)
}